"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedClient = exports.getClient = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _apollo3CachePersist = require("apollo3-cache-persist");
var _browserStorage = _interopRequireDefault(require("../utils/browserStorage"));
var _link = require("../utils/link");
const cache = new _client.InMemoryCache();
let client;
let feedClient;
const PersistedApollo = _ref => {
  let {
    graphQLUrl,
    activityFeedBff,
    onAuthIssue,
    children
  } = _ref;
  const [ready, setReady] = React.useState(false);
  const store = (0, _browserStorage.default)();
  React.useEffect(() => {
    (async () => {
      await (0, _apollo3CachePersist.persistCache)({
        cache,
        // @ts-ignore
        storage: store
      });
      client = new _client.ApolloClient({
        cache,
        link: (0, _link.createLink)({
          graphQLUrl,
          onAuthIssue
        })
      });
      // this should pe temporarily until hiera is updated
      if (activityFeedBff) {
        feedClient = new _client.ApolloClient({
          cache,
          link: (0, _link.createLink)({
            graphQLUrl: activityFeedBff,
            onAuthIssue
          })
        });
      }
      setReady(true);
    })();
  }, []);
  if (!ready) return null;

  // @ts-ignore
  return /*#__PURE__*/React.createElement(_client.ApolloProvider, {
    client: client
  }, children);
};

/* istanbul ignore next */
const getClient = () => client;
exports.getClient = getClient;
const getFeedClient = () => feedClient;
exports.getFeedClient = getFeedClient;
var _default = exports.default = PersistedApollo;